import { useState, useEffect } from "react";
import { Zap, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Analytics } from "@/lib/analytics";
import { signupUrl } from "@/lib/productApp";
import { AnimatePresence, motion } from "framer-motion";
import CalendlyModal from "@/components/CalendlyModal";
import type { AdsMode } from "./AdsModeSelector";
import { useIsMobile } from "@/hooks/use-mobile";

const ctaLabels: Record<AdsMode, string> = {
  vente: "Essai gratuit 7 jours",
  location: "Essai gratuit 7 jours",
};

const AdsStickyBar = ({ mode }: { mode: AdsMode }) => {
  const [visible, setVisible] = useState(false);
  const [calendlyOpen, setCalendlyOpen] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    const hero = document.querySelector("section");
    if (!hero) return;

    const observer = new IntersectionObserver(
      ([entry]) => setVisible(!entry.isIntersecting),
      { threshold: 0 }
    );
    observer.observe(hero);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <AnimatePresence>
        {visible && (
          <motion.div
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 100, opacity: 0 }}
            transition={{ type: "spring", stiffness: 400, damping: 30 }}
            className="fixed bottom-0 inset-x-0 z-50 bg-background/80 backdrop-blur-lg border-t border-border/50 py-3 px-4"
          >
            <div className="container mx-auto flex items-center justify-start sm:justify-center gap-3">
              <Button
                size="sm"
                className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90 font-bold shadow-warm-lg"
                asChild
              >
                <a
                  href={signupUrl()}
                  onClick={() => Analytics.ctaClicked("sticky_signup", "ads_sticky_bar")}
                >
                  <Zap className="w-4 h-4 mr-1.5" />
                  {ctaLabels[mode]}
                </a>
              </Button>
              {!isMobile && (
                <button
                  className="text-xs text-muted-foreground hover:text-foreground transition-colors"
                  onClick={() => {
                    Analytics.ctaClicked("sticky_demo", "ads_sticky_bar");
                    setCalendlyOpen(true);
                  }}
                >
                  <Calendar className="w-3 h-3 inline mr-1" />
                  Réserver une démo
                </button>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <CalendlyModal open={calendlyOpen} onOpenChange={setCalendlyOpen} source="ads_sticky_bar" />
    </>
  );
};

export default AdsStickyBar;
